export default __webpack_public_path__ + "static/media/vandals.dbb50155.png";